module.exports = __webpack_public_path__ + "img/pd-img-head2.a111bc58.png";